import * as Sentry from '@sentry/react'

// Sentry client init for agents-hub-client (project: agenthub-client in the
// era-a2 org). Imported FIRST in main.tsx so instrumentation is installed
// before any app code runs.
//
// Scope: errors, performance tracing, and structured logs (incl. console
// capture). Session Replay is intentionally NOT enabled, so the replay bundle
// tree-shakes out.
Sentry.init({
  dsn: 'https://1df943d4e0e5dfd66c2c427d7765bbd6@o4509068912558080.ingest.us.sentry.io/4511449499041792',

  // Environment: explicit var per deployment (e.g. staging | production).
  // Falls back to Vite MODE for local dev. Set VITE_SENTRY_ENVIRONMENT in each
  // deploy environment to distinguish builds that share MODE === 'production'.
  environment:
    import.meta.env.VITE_SENTRY_ENVIRONMENT ||
    import.meta.env.MODE ||
    'development',

  integrations: [
    Sentry.browserTracingIntegration(),
    // Console capture: mirror console.warn/console.error into Sentry as
    // breadcrumbs + structured logs.
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
  ],

  // Structured Logs API (Sentry.logger.*) + the console capture above.
  enableLogs: true,

  tracesSampleRate: 0.1,

  // Distributed tracing: attach sentry-trace/baggage headers only to our own
  // API hosts. The (?!login-) negative lookahead EXCLUDES the Auth0 tenant
  // (login-*.eraborn.co): its /oauth/token CORS preflight rejects the
  // `baggage` header, which would fail the token request and cause a login
  // loop. Also excludes third-party CDNs/iframes for the same reason.
  tracePropagationTargets: [
    'localhost',
    /^\//,
    /^https:\/\/(?!login-)[\w-]+\.eraborn\.co/,
  ],
})
